import { Sizes } from '@thebeansgroup/sb_ui/style_helpers'
import Colours from '@thebeansgroup/ui_style_helpers/colours'

import { FACEBOOK_COLOUR } from './constants'

export default {
  button: {
    circle: {
      base: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'middle',
        width: Sizes(18),
        height: Sizes(18),
        margin: `0 ${Sizes(-7)}`,
        padding: '0',
        cursor: 'pointer',
        background: 'none',
        borderRadius: '50%',
        border: `1px solid ${Colours('liquorice', '200')}`
      },

      focused: {
        border: `1px solid ${Colours('liquorice', '300')}`
      }
    },

    rectangle: {
      base: {
        position: 'relative',
        display: 'block',
        width: '100%',
        cursor: 'pointer',
        height: Sizes(12),
        marginBottom: Sizes(-7),
        borderRadius: '5px'
      },

      Facebook: {
        color: Colours('white', '300'),
        backgroundColor: FACEBOOK_COLOUR,
        border: 'none'
      },

      Google: {
        color: Colours('liquorice', '400'),
        backgroundColor: Colours('white', '300'),
        border: `1px solid ${Colours('liquorice', '200')}`
      },

      focused: {
        outline: `2px solid ${Colours('berryBlue', '200')}`
      }
    }
  },

  loader: {
    circle: {
      Facebook: {
        colour: Colours('liquorice', '300')
      },

      Google: {
        colour: Colours('liquorice', '300')
      }
    },

    rectangle: {
      Facebook: {
        colour: Colours('white', '300')
      },

      Google: {
        colour: Colours('liquorice', '400')
      }
    }
  },

  icon: {
    verticalAlign: 'sub',
    marginRight: Sizes(-3)
  },

  iconCircular: {
    position: 'absolute',
    top: '16px',
    left: '16px'
  }
}
